import React from 'react';
import { useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

import { Select, Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

import _ from 'underscore';

const ppnOptions = [
  { value: 11, label: 'PPn 11' },
  { value: 1.1, label: 'PPn 1.1' },
  { value: 12, label: 'PPn 12' },
  { value: 1.2, label: 'PPn 1.2' },
  { value: 2, label: 'PPh 23' },
  { value: 9, label: 'PPn + PPh 23' },
  { value: 10, label: 'PPn 10' },
  { value: 1, label: 'PPn 1' },
];

const initialState = {
  products: [
    {
      product: null,
      product_id: null,
      description: '',
      quantity: null,
      unit: null,
      unit_id: null,
      unit_price: null,
      discount: null,
      tax: null,
      unit_nett: null
    },
  ],
};

export const FormProduct = ({ data, onChange, loading, project }) => {
  const StateForm = useSelector((state) => state?.Form);
  const [{ products }, setState] = React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const $handleProductChange = async (i, e, n) => {
    let newProducts = [...products];
    if (e?.target?.name) {
      if (e?.target?.valueNumber) {
        newProducts[i][e.target.name] = e.target.valueNumber;
      } else {
        newProducts[i][e.target.name] = e.target.value;
      }
    } else {
      newProducts[i][n] = e;
      if (e?.id) {
        newProducts[i][`${n}_id`] = e?.id;
      }
    }

    if (n === 'product') {
      newProducts[i]["description"] = ''
      newProducts[i]["quantity"] = null
      newProducts[i]["unit"] = null
      newProducts[i]["unit_id"] = null
      newProducts[i]["unit_price"] = null
      newProducts[i]["discount"] = null
      newProducts[i]["tax"] = null

      if (e) {
        newProducts[i]["quantity"] = 1
        newProducts[i]["unit_price"] = e?.unit_price
        let dtax = null
        if (project) {
          _.each(ppnOptions, (po) => {
            if (po?.value === project?.ppn) {
              dtax = po
            }
          })

          newProducts[i]["tax"] = dtax
        }
      }
    }

    if (n === 'unit') {
      if (e) {
        newProducts[i]["unit_price"] = e?.unit_price
      }
    }

    newProducts[i]["unit_nett"] = (newProducts[i].quantity * newProducts[i].unit_price) - newProducts[i].discount

    setState((prevState) => ({
      ...prevState,
      products: newProducts,
    }));
  };

  const $addMoreFields = async (i) => {
    setState((prevState) => ({
      ...prevState,
      products: [
        ...products,
        {
          product: null,
          product_id: null,
          description: '',
          quantity: null,
          unit: null,
          unit_id: null,
          unit_price: null,
          discount: null,
          tax: null,
          unit_nett: null
        },
      ],
    }));
  };

  const $removeField = async (i) => {
    let newProducts = [...products];
    newProducts.splice(i, 1);
    setState((prevState) => ({
      ...prevState,
      products: newProducts,
    }));
  };

  React.useEffect(() => {
    let newProducts = [];

    if (products) {
      products?.forEach((p) => {
        if (p.discount === "") {
          p.discount = 0
        }

        newProducts.push(p)
      });
    }

    onChange(newProducts);
  }, [products]);

  React.useEffect(() => {
    if (!data) return;

    let p = [];
    if (data) {
      data?.forEach((i) => {
        let ppn = null
        _.each(ppnOptions, (po) =>  {
          if (po?.label === i?.tax?.text) {
            ppn = po
          }
        })

        p.push({
          id: i?.id,
          product: i?.product,
          product_id: i?.product?.id,
          description: i?.description,
          quantity: i?.quantity,
          unit: i?.unit,
          unit_id: i?.unit?.id,
          unit_price: i?.unit_price,
          discount: i?.discount,
          tax: ppn,
          unit_nett: i?.unit_nett,
        });
      });
    }
    setState((prevState) => ({ ...prevState, products: p }));
  }, [data]);

  React.useEffect(() => {
    if (!data) {
      setState({
        products: [
          {
            product: null,
            product_id: null,
            description: '',
            quantity: null,
            unit: null,
            unit_id: null,
            unit_price: null,
            discount: null,
            tax: null,
            unit_nett: null
          },
        ],
      });
    }
  }, []);

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6">Data Product</div>
      {loading ? (
        <div className="row ">
          {dummy?.map((d, i) => (
            <div className="col-md-3" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <div className="py-2">
          <table
            width="100%"
            className={cn(
              'table table-vcenter card-table datatable border',
              StateForm?.errors?.orders ? 'border-danger' : ''
            )}
          >
            <thead className="bg-light">
              <tr className="th">
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  Produk
                </td>
                <td style={{ whiteSpace: 'initial', width: '200px' }}>
                  Deskripsi
                </td>
                <td style={{ whiteSpace: 'initial', width: '100px'}}>
                  Kuantitas
                </td>
                <td style={{ whiteSpace: 'initial', width: '150px'}}>
                  Unit
                </td>
                <td style={{ whiteSpace: 'initial', width: '100px'}}>
                  Harga Satuan
                </td>
                <td style={{ whiteSpace: 'initial', width: '100px'}}>
                  Diskon (Rp)
                </td>
                <td style={{ whiteSpace: 'initial', width: '150px'}}>
                  Pajak
                </td>
                <td style={{ whiteSpace: 'initial', width: '100px'}}>
                  Jumlah
                </td>
                <td style={{ whiteSpace: 'initial', width: '80px'}}>
                  &nbsp;
                </td>
              </tr>
            </thead>
            <tbody>
              {products?.map((e, i) => (
                <tr
                  key={i}
                  className={cn(
                    StateForm?.errors[`products.${i}.product_id`]
                    ? 'text-danger border-danger'
                    : null
                  )}
                >
                  <td style={{ whiteSpace: 'initial', width: '200px' }}>
                    <div className="mb-3">
                      <Select.Remote
                        placeholder=""
                        url="/product"
                        value={e?.product_id}
                        initialValue={e?.product_id}
                        keys={e?.product_id}
                        params={{ is_active: 'active' }}
                        name="product_id"
                        row={(d) => {
                          return {
                            value: d?.id,
                            label: d?.name,
                          };
                        }}
                        onSelected={(e) => $handleProductChange(i, e, 'product')}
                        errors={
                          StateForm?.errors?.products ||
                          StateForm?.errors[`products.${i}.product_id`]
                        }
                      />
                    </div>
                  </td>
                  {e?.product && (
                    <>
                      <td style={{ whiteSpace: 'initial', width: '200px' }}>
                        <Form.Input
                          autoComplete="off"
                          name="description"
                          type="text"
                          value={e?.description}
                          onChange={(e) => $handleProductChange(i, e)}
                          error={
                            StateForm?.errors?.products ||
                            StateForm?.errors[`products.${i}.description`]
                          }
                        />
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '100px' }}>
                        <Form.Input
                          autoComplete="off"
                          name="quantity"
                          type="number"
                          value={e?.quantity}
                          onChange={(e) => $handleProductChange(i, e)}
                          error={
                            StateForm?.errors?.products ||
                            StateForm?.errors[`products.${i}.quantity`]
                          }
                        />
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '150px' }}>
                        <div className="mb-3">
                          <Select.Remote
                            placeholder=""
                            url={`/product/${e?.product_id}/units`}
                            value={e?.unit_id}
                            initialValue={e?.unit_id}
                            keys={e?.unit_id || e?.product_id}
                            name="unit_id"
                            row={(d) => {
                              return {
                                value: d?.id,
                                label: d?.unit,
                              };
                            }}
                            onSelected={(e) => $handleProductChange(i, e, 'unit')}
                            errors={
                              StateForm?.errors?.products ||
                              StateForm?.errors[`products.${i}.unit_id`]
                            }
                          />
                        </div>
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '100px' }}>
                        <Form.Input
                          autoComplete="off"
                          name="unit_price"
                          type="number"
                          value={e?.unit_price}
                          onChange={(e) => $handleProductChange(i, e)}
                          error={
                            StateForm?.errors?.products ||
                            StateForm?.errors[`products.${i}.unit_price`]
                          }
                        />
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '100px' }}>
                        <Form.Input
                          autoComplete="off"
                          name="discount"
                          type="number"
                          value={e?.discount}
                          onChange={(e) => $handleProductChange(i, e)}
                          error={
                            StateForm?.errors?.products ||
                            StateForm?.errors[`products.${i}.discount`]
                          }
                        />
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '150px' }}>
                        <div className="mb-3">
                          <Select
                            isClearable
                            classNamePrefix={
                              (StateForm?.errors?.products ||
                              StateForm?.errors[`products.${i}.tax`])
                              ? 'is-invalid'
                              : 'select'
                            }
                            placeholder=""
                            value={e?.tax}
                            options={ppnOptions}
                            onChange={(e) => $handleProductChange(i, e, 'tax')}
                            error={
                              StateForm?.errors?.products ||
                              StateForm?.errors[`products.${i}.tax`]
                            }
                          />
                        </div>
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '100px' }}>
                        <Form.Input
                          autoComplete="off"
                          name="unit_nett"
                          type="number"
                          value={e?.unit_nett}
                          readOnly
                          error={
                            StateForm?.errors?.products ||
                            StateForm?.errors[`products.${i}.unit_nett`]
                          }
                        />
                      </td>
                      <td style={{ whiteSpace: 'initial', width: '80px' }}>
                        <button
                          type="button"
                          className="btn btn-danger rounded mb-3"
                          style={{ minHeight: 30, minWidth: '100%' }}
                          onClick={() => $removeField(i)}
                          disabled={products?.length === 1}
                        >
                          <Fi.FiX />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
                <tr>
                  <td colSpan={9}>
                    <button
                      type="button"
                      className="btn btn-primary rounded mb-3"
                      style={{ minHeight: 36, minWidth: '100%' }}
                      onClick={() => $addMoreFields()}
                    >
                      <Fi.FiPlus className="me-2" /> Tambah Item
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
};